var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { forwardRef } from "react";
import { styled, Box } from "@mui/material";
import RcUpload from "rc-upload";
import { unstable_composeClasses as composeClasses } from "@mui/base";
import UploadItems from "./UploadList/index";
import { file2Obj, getFileItem, updateFileList, removeFileItem } from "./utils";
import { useMergedState } from "../../hooks";
import UploadChildrenButton from "./UploadChildren/Button";
import UploadChildrenDragger from "./UploadChildren/Dragger";
import UploadChildrenCube from "./UploadChildren/Cube";
import { getUploadUtilityClass } from "./uploadClasses";
var LIST_IGNORE = "__LIST_IGNORE_".concat(Date.now(), "__");
var useUtilityClasses = function (ownerState) {
    var _a = ownerState;
    var slots = {
        root: ["root"],
        button: ["button"],
        drop: ["drop"],
        cube: ["cube"],
        uploadList: ["uploadList"],
        uploadListItem: ["uploadListItem"],
        uploadListItemSelected: ["uploadListItemSelected"],
    };
    return composeClasses(slots, getUploadUtilityClass, {});
};
var UploadRoot = styled(Box)(function (_a) {
    var ownerState = _a.ownerState;
    return __assign({}, (ownerState.type === "cube" && {
        display: "flex",
    }));
});
var UploadListRoot = styled(Box)(function (_a) {
    var ownerState = _a.ownerState;
    var type = ownerState.type, uploadListPlace = ownerState.uploadListPlace;
    return __assign(__assign({}, (type === "cube" && { display: "flex", flex: true })), (type !== "cube" && __assign(__assign({}, (uploadListPlace === "top" && {
        marginBottom: 10,
    })), (uploadListPlace === "bottom" && {
        marginTop: 10,
    }))));
});
var Upload = forwardRef(function (props, ref) {
    var type = props.type, accept = props.accept, capture = props.capture, name = props.name, multiple = props.multiple, childrenProp = props.children, action = props.action, customRequest = props.customRequest, fileList = props.fileList, defaultFileList = props.defaultFileList, maxCount = props.maxCount, headers = props.headers, showUploadList = props.showUploadList, _a = props.uploadListPlace, uploadListPlace = _a === void 0 ? props.type === "cube" ? "before" : "after" : _a, itemRender = props.itemRender, onChange = props.onChange, onRemove = props.onRemove, onDrop = props.onDrop, onSelect = props.onSelect, selected = props.selected, UploadListProps = props.UploadListProps, icon = props.icon, variant = props.variant, color = props.color, restProps = __rest(props, ["type", "accept", "capture", "name", "multiple", "children", "action", "customRequest", "fileList", "defaultFileList", "maxCount", "headers", "showUploadList", "uploadListPlace", "itemRender", "onChange", "onRemove", "onDrop", "onSelect", "selected", "UploadListProps", "icon", "variant", "color"]);
    var captureProps = capture != null ? { capture: capture } : {};
    var _b = useMergedState(defaultFileList || [], {
        value: fileList,
        postState: function (list) { return list !== null && list !== void 0 ? list : []; },
    }), mergedFileList = _b[0], setMergedFileList = _b[1];
    var _c = React.useState("drop"), dragState = _c[0], setDragState = _c[1];
    var _d = React.useState(), uploadedFile = _d[0], setUploadedFile = _d[1];
    var upload = React.useRef();
    // 自动填入uid
    React.useMemo(function () {
        var timestamp = Date.now();
        (fileList || []).forEach(function (file, index) {
            if (!file.uid && !Object.isFrozen(file)) {
                file.uid = "__AUTO__".concat(timestamp, "_").concat(index, "__");
            }
        });
    }, [fileList]);
    var mergedBeforeUpload = function (file, fileListArgs) { return __awaiter(void 0, void 0, void 0, function () {
        var beforeUpload, parsedFile, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    beforeUpload = props.beforeUpload;
                    parsedFile = file;
                    if (!beforeUpload) return [3 /*break*/, 2];
                    return [4 /*yield*/, beforeUpload(file, fileListArgs)];
                case 1:
                    result = _a.sent();
                    if (result === false) {
                        return [2 /*return*/, false];
                    }
                    delete file[LIST_IGNORE];
                    if (result === LIST_IGNORE) {
                        Object.defineProperty(file, LIST_IGNORE, {
                            value: true,
                            configurable: true,
                        });
                        return [2 /*return*/, false];
                    }
                    if (typeof result === "object" && result) {
                        parsedFile = result;
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/, parsedFile];
            }
        });
    }); };
    var onInternalChange = function (file, changedFileList, event) {
        var cloneList = __spreadArray([], changedFileList, true);
        if (maxCount === 1) {
            cloneList = cloneList.slice(-1);
        }
        else if (maxCount) {
            cloneList = cloneList.slice(0, maxCount);
        }
        cloneList = cloneList === null || cloneList === void 0 ? void 0 : cloneList.filter(function (t) { return t.status; });
        setMergedFileList(cloneList);
        var changeInfo = {
            file: file,
            fileList: cloneList,
        };
        if (event) {
            changeInfo.event = event;
        }
        setUploadedFile(file);
        onChange === null || onChange === void 0 ? void 0 : onChange(changeInfo);
    };
    var onBatchStart = function (batchFileInfoList) {
        var filteredFileInfoList = batchFileInfoList.filter(function (info) { return !info.file[LIST_IGNORE]; });
        if (!filteredFileInfoList.length) {
            return;
        }
        var objectFileList = filteredFileInfoList.map(function (info) {
            return file2Obj(info.file);
        });
        var newFileList = __spreadArray([], mergedFileList, true);
        objectFileList.forEach(function (fileObj) {
            newFileList = updateFileList(fileObj, newFileList);
        });
        objectFileList.forEach(function (fileObj, index) {
            var triggerFileObj = fileObj;
            if (!filteredFileInfoList[index].parsedFile) {
                var originFileObj = fileObj.originFileObj;
                var clone = void 0;
                try {
                    clone = new File([originFileObj], originFileObj.name, {
                        type: originFileObj.type,
                    });
                }
                catch (e) {
                    clone = new Blob([originFileObj], {
                        type: originFileObj.type,
                    });
                    clone.name = originFileObj.name;
                    clone.lastModifiedDate = new Date();
                    clone.lastModified = new Date().getTime();
                }
                clone.uid = fileObj.uid;
                triggerFileObj = clone;
            }
            else {
                fileObj.status = "uploading";
            }
            onInternalChange(triggerFileObj, newFileList);
        });
    };
    var onSuccess = function (response, file, xhr) {
        try {
            if (typeof response === "string") {
                response = JSON.parse(response);
            }
        }
        catch (e) {
            /* do nothing */
        }
        // removed
        if (!getFileItem(file, mergedFileList)) {
            return;
        }
        var targetItem = file2Obj(file);
        targetItem.status = "done";
        targetItem.percent = 100;
        targetItem.response = response;
        targetItem.xhr = xhr;
        var nextFileList = updateFileList(targetItem, mergedFileList);
        onInternalChange(targetItem, nextFileList);
    };
    var onError = function (error, response, file) {
        // removed
        if (!getFileItem(file, mergedFileList)) {
            return;
        }
        var targetItem = file2Obj(file);
        targetItem.error = error;
        targetItem.response = response;
        targetItem.status = "error";
        var nextFileList = updateFileList(targetItem, mergedFileList);
        onInternalChange(targetItem, nextFileList);
    };
    var onFileDrop = function (e) {
        setDragState(e.type);
        if (e.type === "drop") {
            onDrop === null || onDrop === void 0 ? void 0 : onDrop(e);
        }
    };
    var onProgress = function (e, file) {
        // removed
        if (!getFileItem(file, mergedFileList)) {
            return;
        }
        var targetItem = file2Obj(file);
        targetItem.status = "uploading";
        targetItem.percent = e.percent;
        var nextFileList = updateFileList(targetItem, mergedFileList);
        onInternalChange(targetItem, nextFileList, e);
    };
    var handleRemove = function (file) {
        var currentFile;
        Promise.resolve(typeof onRemove === "function" ? onRemove(file) : onRemove).then(function (ret) {
            var _a;
            // Prevent removing file
            if (ret === false) {
                return;
            }
            var removedFileList = removeFileItem(file, mergedFileList);
            if (removedFileList) {
                currentFile = __assign(__assign({}, file), { status: "removed" });
                mergedFileList === null || mergedFileList === void 0 ? void 0 : mergedFileList.forEach(function (item) {
                    var matchKey = currentFile.uid !== undefined ? "uid" : "name";
                    if (item[matchKey] === currentFile[matchKey] &&
                        !Object.isFrozen(item)) {
                        item.status = "removed";
                    }
                });
                (_a = upload.current) === null || _a === void 0 ? void 0 : _a.abort(currentFile);
                onInternalChange(currentFile, removedFileList);
                setUploadedFile(undefined); // TODO: 加上它之后是否有副作用
            }
        });
    };
    var handleRefresh = function (file) {
        var _a, _b;
        var uploadFiles = (_b = (_a = upload === null || upload === void 0 ? void 0 : upload.current) === null || _a === void 0 ? void 0 : _a.uploader) === null || _b === void 0 ? void 0 : _b.uploadFiles;
        if (!uploadFiles || typeof uploadFiles !== "function") {
            return console.warn("uploadFiles方法不存在");
        }
        uploadFiles([file]);
    };
    var handleSelect = function () { };
    React.useImperativeHandle(ref, function () {
        var _a;
        return ({
            onBatchStart: onBatchStart,
            onSuccess: onSuccess,
            onProgress: onProgress,
            onError: onError,
            fileList: mergedFileList,
            upload: upload.current,
            uploader: (_a = upload === null || upload === void 0 ? void 0 : upload.current) === null || _a === void 0 ? void 0 : _a.uploader,
        });
    });
    var classes = useUtilityClasses({});
    var children = null;
    if (type === "drop") {
        children = (React.createElement(UploadChildrenDragger, { className: classes.drop, status: dragState, file: uploadedFile, onRemove: handleRemove, multiple: multiple }, childrenProp));
    }
    else if (type === "cube") {
        children = (React.createElement(UploadChildrenCube, { className: classes.cube, file: uploadedFile, onRemove: handleRemove }, childrenProp));
    }
    else if (type === "button") {
        children = (React.createElement(UploadChildrenButton, { className: classes.button, variant: variant, color: color, icon: icon }, childrenProp));
    }
    else if (type === "custom") {
        if (typeof childrenProp === "function") {
            children = childrenProp(mergedFileList, {
                handleRemove: handleRemove,
                handleRefresh: handleRefresh,
                dragState: dragState,
            });
        }
        else {
            children = childrenProp;
        }
    }
    var ownerState = {
        type: type,
        uploadListPlace: uploadListPlace,
    };
    var isShowUploadButton = maxCount == null ||
        (typeof maxCount === "number" && mergedFileList.length < maxCount) ||
        !showUploadList;
    var uploadButton = (React.createElement(RcUpload, __assign({ ref: upload, name: name, accept: accept, action: action, multiple: multiple, headers: headers, customRequest: customRequest, beforeUpload: mergedBeforeUpload, onBatchStart: onBatchStart, onSuccess: onSuccess, onError: onError, onProgress: onProgress, style: isShowUploadButton ? {} : { display: "none" } }, captureProps), children));
    var uploadList = showUploadList ? (React.createElement(UploadListRoot, __assign({ className: classes.uploadList, ownerState: ownerState }, UploadListProps),
        React.createElement(UploadItems, { type: type, selected: selected, items: mergedFileList, onRemove: handleRemove, onRefresh: handleRefresh, onSelect: onSelect, itemRender: itemRender, classes: {
                root: classes.uploadListItem,
                selected: classes.uploadListItemSelected,
            } }))) : null;
    return (React.createElement(UploadRoot, __assign({ ownerState: ownerState, onDrop: onFileDrop, onDragOver: onFileDrop, onDragLeave: onFileDrop, className: classes.root }, restProps),
        (uploadListPlace === "top" || uploadListPlace === "before") &&
            uploadList,
        uploadButton,
        (uploadListPlace === "bottom" || uploadListPlace === "after") &&
            uploadList));
});
Upload.defaultProps = {
    multiple: false,
    action: "",
    data: {},
    accept: "",
    type: "button",
    showUploadList: true,
};
export default Upload;
